import round from "lodash/round";

export function findPercentComplete(program, cycle) {
  if (!program) {
    return 0;
  }
  const numSessions = program && program.sessions ? program.sessions.length : 0;
  const thisSessionNumber =
    (cycle.programWeek - 1) * program.sessionsPerWeek + cycle.programSession;
  const percentComplete = round((thisSessionNumber / numSessions) * 100, 0);
  return percentComplete > 100 ? 100 : percentComplete;
}
